import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CloudLoader from './../loader/Loader_02';

export default function Welcome({ status, highlights, contentData, initError, initLoader }) {
  let navigate = useNavigate();

  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [
    'SEE WHAT WE OFFERS',
    'RENT 0.0015 BTC / YEAR',
    'MINING 0.0000402 BTC / DAY',
    'ZERO PLATFORM FEE',
    'ZERO SERVICE CHARGES',
    'EVENTS & CHALLENGES',
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  let isOk = (status ? (status === "200" ? true : false) : false);

  return (
    <>
      {isOk && <div>
        <div className="carousel">
          <div className="slides" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
            {slides.map((text, index) => (
              <div key={index} className="slide"><h2>{text}</h2></div>
            ))}
          </div>
          <button className="prev" onClick={prevSlide}><span className="left-arrow"></span></button>
          <button className="next" onClick={nextSlide}><span className="right-arrow"></span></button>
        </div>
        <button className="getting-started" onClick={() => navigate("/getting-started", { replace: true })}><h3>Getting Started</h3></button>
        <br/>
        <div className="highlights-grid">
          {highlights.map((highlight, index) => (
            <div key={index} className="highlight-item">
              <br/>
              <h3 className="highlight-title">{highlight.content}</h3>
              <h5 className="highlight-message">{highlight.title}</h5>
              <br/>
            </div>
          ))}
        </div>
      </div>}
      
      {initLoader && <CloudLoader />}
      {initError && <p style={{ color: "red" }}>Init Error - {initError.message}</p>}
    </>
  );
}
